import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
 
@Injectable({ providedIn: 'root' })
export class SharedDataBridgeService {
 
  constructor(private route: ActivatedRoute) {}
 
  private endpointSource = new BehaviorSubject<string | null>(null);
  public endpoint$ = this.endpointSource.asObservable();
 
  setEndpoint(endpoint: string) {
    this.endpointSource.next(endpoint);
  }
 
  hasEndpoint(): boolean {
    const queryParams = this.route.snapshot.queryParams;
    return Object.keys(queryParams).length > 0;
  }
}